/* global rp$, window, document */

import debounce from 'lodash/debounce';
import './promotional_banner.scss';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');
	require('core-js/fn/array/for-each');

	(function promotionalBannerModule(){
		$onReady({
			rp$, window,
			label: 'promotional_banner',
			fn: function () {
				var $promotional_banners = rp$('.promotional-banner-wrap');

				var bannerCopy = function($banner_wrap) {
					return $banner_wrap.find('.promotional-banner-link, .promotional-banner-text-wrap');
				};

				var syncOverflow = function($banner_wrap) {
					if ($banner_wrap.is('.promo-expand') || !$banner_wrap.is(':visible')) {
						return;
					}

					var text_el = bannerCopy($banner_wrap).get(0);
					var has_overflow = !!(text_el && text_el.scrollWidth > text_el.clientWidth);
					$banner_wrap.toggleClass('text-wrapping', has_overflow);
				};

				rp$.each($promotional_banners, function promotionalBanner_Iterator(idx, promo_ban_ele){
					var $banner_wrap = rp$(promo_ban_ele);
					var $banner_copy = bannerCopy($banner_wrap);

					$banner_wrap.on('click', function promoExpandText() {
						if (!$banner_wrap.is('.text-wrapping')) {
							return;
						}

						if ($banner_wrap.is('.promo-expand')) {
							$banner_copy.css('white-space', 'nowrap');
							$banner_wrap.removeClass('promo-expand');
							syncOverflow($banner_wrap);
						} else {
							$banner_copy.css('white-space', 'normal');
							$banner_wrap.addClass('promo-expand');
						}
					});

					syncOverflow($banner_wrap);
				});

				rp$(window).on('resize', debounce(function() {
					rp$.each($promotional_banners, function(idx, promo_ban_ele) {
						syncOverflow(rp$(promo_ban_ele));
					});
				}, 50));
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
